import { render, staticRenderFns } from "./CarouselForm.vue?vue&type=template&id=760ca48f&scoped=true"
import script from "./CarouselForm.vue?vue&type=script&lang=js"
export * from "./CarouselForm.vue?vue&type=script&lang=js"
import style0 from "./CarouselForm.vue?vue&type=style&index=0&id=760ca48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ca48f",
  null
  
)

export default component.exports